/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from "react";
import DataTableComponent, { ColumnOption } from "../../../../common/DataTable";
import { Dialog } from "primereact/dialog";
import { Paginator, PaginatorPageChangeEvent } from "primereact/paginator";
import { ProgressSpinner } from "primereact/progressspinner";
import {
  appTimeBodyTemplate,
  appTimeLogBodyTemplate,
  dateBodyTemplate,
  descriptionBodyTemplate,
  managerTimeBodyTemplate,
  projectNameBodyTemplate,
  statusBodyTemplate,
  tableHeaderTemplate,
  // trackerTimeBodyTemplate,
} from "../../common/TimeLogTemplates";
import { fetchMyLogsData } from "./fetchData";
import { Toast } from "primereact/toast";
import { TLFilterContext } from "../TL_FiltersContext";
import { Timeline } from "primereact/timeline";
import { Card } from "primereact/card";
import { Tooltip } from "primereact/tooltip";
import { managerTimeListingBodyTemplate } from "../../common/TimeLogTemplates-teamlogs";

const MyLogs = () => {
  const toast = useRef<Toast>(null);
  const context = useContext(TLFilterContext);
  if (!context) {
    throw new Error("FilterPage must be used within a FilterProvider");
  }

  const { filters, setFilters } = context;
  const [myLogsDataLoading, setMyLogsDataLoading] = useState<boolean>(false);
  const [sortFilter, setSortFilter] = useState<any>({
    sortField: "log_date",
    sortOrder: false,
  });

  const [timeLogDetails, setTimeLogDetails] = useState<any>([]);

  const [visible, setVisible] = useState<boolean>(false);
  const [adminComments, setAdminComments] = useState<string>("");
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);

  const [first, setFirst] = useState<number>(0);
  const [size, setSize] = useState<number>(10);
  const [totalRecords, setTotalRecords] = useState<number>(10); // To hold the total number of records

  const [showTimeLogDetails, setShowTimeLogDetails] = useState<boolean>(false);
  const [myLogsData, setMyLogsData] = useState<any[]>([]);
  const [timelogActivity, setTimelogActivity] = useState<any>([]);
  const [viewHistoryPopup, setViewHistoryPopup] = useState<boolean>(false);

  useEffect(() => {
    fetchMyLogsData({
      size,
      page: first,
      setTotalRecords,
      sortFilter,
      setMyLogsData,
      setMyLogsDataLoading,
      filters: filters.endDate && filters,
      toast: toast,
    });
  }, [sortFilter, filters]);

  const onPageChange = (event: PaginatorPageChangeEvent) => {
    setFirst(event.first);
    setSize(event.rows); // Set the number of rows per page
    const currentPage = Math.floor(event.first / event.rows); // Calculate the current page index
    fetchMyLogsData({
      page: currentPage,
      size: event.rows,
      setTotalRecords,
      sortFilter,
      setMyLogsData: setMyLogsData,
      setMyLogsDataLoading: setMyLogsDataLoading,
      filters: filters.endDate && filters,
      toast: toast,
    });
  };

  const myLogsColumns: ColumnOption[] = [
    {
      field: "log_date",
      header: tableHeaderTemplate("Date", "log_date", setSortFilter),
      body: dateBodyTemplate,
      visible: true,
    },
    {
      field: "registration_no",
      header: tableHeaderTemplate(
        "Vehicle Registration",
        "registration_no",
        setSortFilter
      ),
      visible: true,
    },
    {
      field: "projectKeys",
      header: tableHeaderTemplate("Projects", "projectKeys", setSortFilter),
      body: (e: any) => {
        // const projectNames = e?.timelogdetails
        //   ?.map((project: any) => project?.projectName)
        //   .filter(Boolean)
        //   .join(", ");
        // return (
        //   <span className="tw-text-sm tw-text-[#64748B] tw-font-medium tw-leading-4 tw-break-words tw-whitespace-normal">
        //     {projectNames}
        //   </span>
        // );
        const projectDetails = e?.timelogdetails
          ?.filter((detail: any) => detail?.projectName)
          .map((detail: any) => ({
            name: detail.projectName,
            time: detail.duration,
            description: detail.description,
          }));
        return (
          <div className="tw-flex tw-flex-col tw-gap-2">
            {projectDetails?.map((project: any, index: number) => (
              <div key={index} className="tw-text-sm tw-text-[#64748B]">
                <Tooltip
                  target=".out-project-desc"
                  mouseTrack
                  mouseTrackLeft={10}
                  position="bottom"
                  className="tw-max-w-sm tw-text-sm"
                />
                <div className="tw-font-medium">{project.name}</div>
                <div className="tw-text-xs">
                  {project.time && <span>Time: {project.time}</span>}
                  {project.description && (
                    <span
                      className="tw-ml-2 out-project-desc"
                      data-pr-tooltip={
                        project.description.length > 50
                          ? project.description
                          : undefined
                      }
                    >
                      -{" "}
                      {project.description.length > 50
                        ? `${project.description.substring(0, 50)}.....`
                        : project.description}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        );
      },
      visible: true,
    },
    {
      field: "appTime",
      header: tableHeaderTemplate("Claimed Time", "appTime", setSortFilter),
      body: (e: any) =>
        appTimeBodyTemplate(e, setShowTimeLogDetails, setTimeLogDetails),
      visible: true,
    },
    {
      field: "managerTime",
      header: tableHeaderTemplate("Manager Time", "managerTime", setSortFilter),
      body: (e: any) => managerTimeListingBodyTemplate(e),
      visible: true,
    },
    // {
    //   field: "trackerTime",
    //   header: tableHeaderTemplate("Tracker Time", "trackerTime", setSortFilter),
    //   body: (e: any) => trackerTimeBodyTemplate({ rowData: e, type: "myLogs" }),
    //   visible: true,
    // },
    {
      field: "status",
      header: tableHeaderTemplate("Status", "status", setSortFilter),
      visible: true,
      body: (rowData: any) =>
        statusBodyTemplate(
          rowData,
          setVisible,
          setSelectedRowData,
          setTimelogActivity,
          setViewHistoryPopup
        ),
    },
  ];

  const appTimeProjectViewColumns: ColumnOption[] = [
    {
      field: "projectID",
      header: "Project Name",
      body: projectNameBodyTemplate,
      visible: true,
    },
    {
      field: "start_time",
      header: "Claimed Time",
      body: appTimeLogBodyTemplate,
      visible: true,
    },
    // {
    //   field: "manager_start_time",
    //   header: "Manager Time",
    //   body: managerTimeBodyTemplate,
    //   visible: true,
    // },
    {
      field: "description",
      header: "Description",
      body: descriptionBodyTemplate,
      visible: true,
    },
  ];

  const formatCreatedDate = (dateString: string) => {
    const date = new Date(dateString);

    const day = date.getUTCDate().toString().padStart(2, "0"); // 25
    const month = date.toLocaleString("en-UK", { month: "short" }); // Sep
    const year = date.getUTCFullYear(); // 2024

    const time = date.toLocaleTimeString("en-UK", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${day} ${month} ${year} ${time}`;
  };

  const events: any = timelogActivity?.map((activity: any) => {
    return {
      action: activity?.action,
      date: activity?.createdAt,
      actionTakerDisplayName: activity?.actionTakerDisplayName,
      comment: activity?.comment,
      isWeb: activity?.isWeb,
      lineManagerName: activity?.lineManagerName,
      lineManagerID: activity?.lineManagerID,
      roleName: activity?.roleName,
      status: activity?.status,
      timeLogID: activity?.timeLogID,
      userID: activity?.userID,
      managerHideComment: activity?.managerHideComment,
      adminHideComment: activity?.adminHideComment,
      hrHideComment: activity?.hrHideComment,
    };
  });

  // const events = ["sd", "as", "as"];

  const customizedMarker = () => {
    return (
      <>
        <div className="tw-flex tw-justify-center tw-items-center tw-w-5 tw-h-5 tw-rounded-full tw-bg-[#E2E8F0]">
          <div className="tw-w-3 tw-h-3 tw-rounded-full tw-bg-[#00AFEE]"></div>
        </div>
      </>
    );
  };

  const customizedContent = (item: any) => {
    // const bgColour =
    //   item?.action === "Time log added"
    //     ? "tw-bg-yellow-50"
    //     : item?.action === "Time log submitted"
    //     ? "tw-bg-blue-50"
    //     : item?.action === "Time log updated"
    //     ? "tw-bg-gray-50"
    //     : item?.action === "Tracker time updated by admin"
    //     ? "tw-bg-[#25ccdb]"
    //     : item?.action === "Timelog submitted to manager"
    //     ? "tw-bg-brown-50"
    //     : item?.action === "Timelog approved by manager"
    //     ? "tw-bg-[#f5fff8]"
    //      : item?.action === "Timelog rejected by manager"
    //      ?"tw-bg-red-50"
    //       : item?.action === "Timelog approved by HR"
    //     ? "tw-bg-[#f5fff8]"
    //     :"tw-cyan-50"

    return (
      <>
        {item?.action ? (
          <Card className={`activity-card tw-bg-gray-50`}>
            <div className="activity-container tw-flex tw-justify-between tw-items-center tw-mb-4">
              {/* <span className="po-number tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
            {item?.status}
          </span> */}
              <span className="activity-date tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
                {formatCreatedDate(item?.date)}
              </span>
            </div>
            <span className="activity-content tw-text-ellipsis tw-overflow-hidden tw-max-w-52">
              {item?.action ? (
                item?.action === "Tracker time updated by admin" ||
                item?.action === "Comment added by admin" ||
                item?.action === "Comment added by HR" ||
                item?.action === "Vehicle updated by manager" ||
                item?.action === "Project updated by manager" ||
                item?.action === "Timelog approved by manager" ||
                item?.action === "Timelog unlocked by Admin" ||
                item?.action === "Timelog locked by Admin" ||
                item?.action === "Timelog approved by HR" ||
                item?.action === "Timelog rejected by HR" ||
                item?.action === "Timelog rejected by manager" ||
                item?.action === "Timelog approved by HR" ? (
                  <span>
                    <span className="tw-font-medium tw-text-gray-700">
                      {item?.action}
                    </span>{" "}
                    <span className="tw-text-gray-600">
                      {item.actionTakerDisplayName ?? "N/A"}
                    </span>
                  </span>
                ) : (
                  // `${item?.action} by ${item?.actionTakerDisplayName}`
                  <span>
                    <span className="tw-font-medium tw-text-gray-700">
                      {item?.action}
                    </span>{" "}
                    <span className="tw-text-gray-600">
                      by{" "}
                      {item.actionTakerDisplayName
                        ? item.actionTakerDisplayName
                        : item?.action ===
                          "Timelog was auto-locked and sent to HR for adding tracker time and approval"
                        ? "System"
                        : "N/A"}
                    </span>
                  </span>
                )
              ) : (
                ""
              )}
            </span>
            <div className="tw-flex tw-justify-between tw-items-center tw-mt-1 tw-font-medium tw-text-[#6611119c]">
              <span className="tw-ml-auto">
                {/* Hide comment based on action type and hide flags */}
                {(item?.action === "Timelog approved by manager" ||
                  item?.action === "Timelog rejected by manager") &&
                item?.managerHideComment
                  ? ""
                  : item?.action === "Comment added by admin" &&
                    item?.adminHideComment
                  ? ""
                  : item?.action === "Comment added by HR" &&
                    item?.hrHideComment
                  ? ""
                  : item?.comment}
              </span>
            </div>
          </Card>
        ) : (
          <>
            <div>No History Found</div>
          </>
        )}
      </>
    );
  };

  return (
    <>
      <Toast ref={toast} />

      <div className="tw-container tw-mx-auto">
        {myLogsDataLoading ? (
          <div className="tw-h-full tw-w-full tw-bg-transparent tw-flex tw-justify-center tw-items-center tw-absolute tw-top-0 tw-left-0 tw-z-50">
            <ProgressSpinner />
          </div>
        ) : (
          <>
            {/** Total time div */}
            <div className="tw-flex tw-gap-3 tw-py-2 tw-pl-[10px]">
              <span className="tw-font-medium tw-mr-2 tw-text-[#64748B] tw-text-sm">
                Total Claimed Time :{" "}
                <span className="tw-text-[#152846]">
                  {(() => {
                    // Calculate total seconds from all time logs
                    const totalSeconds = myLogsData.reduce((total, timeLog) => {
                      return (
                        total +
                        timeLog?.timelogdetails?.reduce(
                          (sum: any, detail: any) => {
                            const [hours, minutes, seconds] = detail.duration
                              .split(":")
                              .map(Number);
                            return sum + hours * 3600 + minutes * 60 + seconds;
                          },
                          0
                        )
                      );
                    }, 0);

                    // Convert total seconds to hours and minutes
                    const totalHours = Math.floor(totalSeconds / 3600);
                    const totalMinutes = Math.floor((totalSeconds % 3600) / 60);

                    // Return formatted time string
                    return `${String(totalHours)}:${String(
                      totalMinutes
                    ).padStart(2, "0")} hrs`;
                  })()}
                </span>
              </span>
              <span className="tw-font-medium tw-mr-2 tw-text-[#64748B] tw-text-sm">
                Total Manager Time :{" "}
                <span className="tw-text-[#152846]">
                  {(() => {
                    // Calculate total seconds from all time logs
                    const totalSeconds = myLogsData.reduce((total, timeLog) => {
                      if (timeLog.manager_duration === null) return total;
                      const [hours, minutes, seconds] = timeLog.manager_duration
                        .split(":")
                        .map(Number);
                      return total + hours * 3600 + minutes * 60 + seconds;
                    }, 0);

                    // Convert total seconds to hours and minutes
                    const totalHours = Math.floor(totalSeconds / 3600);
                    const totalMinutes = Math.floor((totalSeconds % 3600) / 60);
                    // Return formatted time string
                    return `${String(totalHours)}:${String(
                      totalMinutes
                    ).padStart(2, "0")} hrs`;
                  })()}
                </span>
              </span>
              {/* <span className="tw-font-medium tw-mr-2 tw-text-[#64748B] tw-text-sm">
                Total Tracker Time :{" "}
                <span className="tw-text-[#00AFEE]">
                  {(() => {
                    // Calculate total seconds from all time logs
                    const totalSeconds = myLogsData.reduce((total, timeLog) => {
                      if (timeLog.tracker_duration === null) return total;
                      const [hours, minutes, seconds] = timeLog.tracker_duration
                        .split(":")
                        .map(Number);
                      return total + hours * 3600 + minutes * 60 + seconds;
                    }, 0);

                    // Convert total seconds to hours and minutes
                    const totalHours = Math.floor(totalSeconds / 3600);
                    const totalMinutes = Math.floor((totalSeconds % 3600) / 60);
                    // Return formatted time string
                    return `${String(totalHours)}:${String(
                      totalMinutes
                    ).padStart(2, "0")} hrs`;
                  })()}
                </span>
              </span> */}
            </div>

            {/* DataTableComponent is a custom component that wraps around PrimeReact DataTable */}
            <DataTableComponent
              rowData={myLogsData}
              columns={myLogsColumns}
              customClass="timelog-datatable"
            />
            <Paginator
              first={first}
              rows={size}
              totalRecords={totalRecords} // Set total records for pagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              onPageChange={onPageChange}
            />
          </>
        )}

        <Dialog
          header={`Time Log : ${localStorage.displayName} ( ${timeLogDetails[0]?.registration_no} )`}
          visible={showTimeLogDetails}
          draggable={false}
          style={{ width: "50vw" }}
          onHide={() => {
            if (!showTimeLogDetails) return;
            setShowTimeLogDetails(false);
          }}
        >
          <DataTableComponent
            rowData={timeLogDetails}
            columns={appTimeProjectViewColumns}
            showGridlines={true}
          />
        </Dialog>

        <Dialog
          className="comments-dialog tw-w-[444px]"
          style={{ maxWidth: "620px" }}
          header="comments"
          visible={visible}
          draggable={false}
          onHide={() => {
            if (!visible) return;
            setVisible(false);
            // setAdminComments("");
            // setIsButtonDisabled(false);
          }}
        >
          <div className="tw-p-6">
            <div className="tw-py-6 tw-flex tw-flex-col tw-gap-2 tw-w-full">
              {selectedRowData?.adminHideComment &&
                selectedRowData?.managerHideComment && (
                  <div className="tw-p-4 tw-border-b tw-text-center tw-border-b-solid tw-border-b-[#DBDBDB]">
                    <p className="tw-m-0 tw-text-sm tw-font-medium tw-text-[#64748B] tw-mb-2">
                      No Comments to Show
                    </p>
                  </div>
                )}
              {!selectedRowData?.adminHideComment &&
                selectedRowData?.admin_comment && (
                  <div className="tw-p-4 tw-border-b tw-border-b-solid tw-border-b-[#DBDBDB]">
                    <p className="tw-m-0 tw-text-base tw-font-medium tw-text-[#64748B] tw-mb-2">
                      Super Admin Notes
                    </p>
                    <p className="tw-m-0 tw-text-base tw-font-medium tw-text-black tw-break-words">
                      {selectedRowData?.admin_comment}
                    </p>
                  </div>
                )}
              {!selectedRowData?.managerHideComment &&
                selectedRowData?.manager_comment && (
                  <div className="tw-p-4 tw-border-b tw-border-b-solid tw-border-b-[#DBDBDB]">
                    <p className="tw-m-0 tw-text-base tw-font-medium tw-text-[#64748B] tw-mb-2">
                      Manager Notes
                    </p>
                    <p className="tw-m-0 tw-text-base tw-font-medium tw-text-black tw-break-words">
                      {selectedRowData?.manager_comment}
                    </p>
                  </div>
                )}
              {selectedRowData?.hr_comment && selectedRowData?.hr_comment && (
                <div className="tw-p-4 tw-border-b tw-border-b-solid tw-border-b-[#DBDBDB]">
                  <p className="tw-m-0 tw-text-base tw-font-medium tw-text-[#64748B] tw-mb-2">
                    HR Notes
                  </p>
                  <p className="tw-m-0 tw-text-base tw-font-medium tw-text-black tw-break-words">
                    {selectedRowData?.hr_comment}
                  </p>
                </div>
              )}
            </div>
          </div>
        </Dialog>

        <Dialog
          className="comments-dialog tw-w-[444px]"
          style={{ maxWidth: "620px" }}
          header={`Timelog History`}
          visible={viewHistoryPopup}
          draggable={false}
          onHide={() => {
            if (!viewHistoryPopup) return;
            setViewHistoryPopup(false);
          }}
        >
          <>
            {/* <Timeline
              className="tw-p-4"
              align="left"
              marker={customizedMarker}
              content={customizedContent}
              value={events}
            /> */}
            {timelogActivity && timelogActivity.length !== 0 ? (
              <Timeline
                className="tw-p-4"
                align="left"
                marker={customizedMarker}
                content={customizedContent}
                value={events}
              />
            ) : (
              <div className="tw-p-4 tw-border-b tw-text-center tw-border-b-solid tw-border-b-[#DBDBDB]">
                <p className="tw-m-0 tw-text-sm tw-font-medium tw-text-[#64748B] tw-mb-2">
                  No History Found
                </p>
              </div>
            )}
          </>
        </Dialog>
      </div>
    </>
  );
};

export default MyLogs;
